<template>
    <FetchError
        v-if="fetchError"
        :heading="siteContent.creatorDoesntExist"
        :text="siteContent.creatorDeletedOrBroken"/>
    <BaseLayout
        v-else>

        <HeroSkeleton
            v-if="userLoading"/>
        <Hero v-else
            :id="currentUser.id"
            :currentUser="currentUser"
            :isSelected="isSelected"
            @updateProfile="updateProfile"
            @changeSelected="changeSelected"/>
        <ProfileNavigation
            :feedSize="feedSize"
            :feedSizeLoading="feedSizeLoading"
            :isSelected="isSelected"
            :id="id"
            @changeSelected="changeSelected"/>

        <Main>
            <FeedSkeleton class="feedSkeleton"
                v-if="feedSize.entries === null && feedSize.posts === null"/>
            <Entries
                v-else-if="isSelected === 'entries' && feedSize.entries > 0"
                :id="currentUser.id"
                :slug="currentUser.slug"/>
            <Drafts
                v-else-if="isVisible('entryDrafts')"
                :id="currentUser.id"
                :slug="currentUser.slug"/>
            <Posts
                v-else-if="isSelected === 'posts' && feedSize.posts > 0"
                :id="currentUser.id"
                :slug="currentUser.slug"/>
            <Unpublished
                v-else-if="isVisible('postDrafts')"
                :id="currentUser.id"
                :slug="currentUser.slug"/>
            <EmptyState v-else/>
        </Main>
    </BaseLayout>
</template>

<script>
    import { db } from '@/firebase'
    import { mapActions, mapState } from 'vuex'

    import BaseLayout                from '@/components/layout/main/BaseLayout'
    import Main                      from '@/components/layout/main/Main'
    import HeroSkeleton              from '@/components/creator/HeroSkeleton'
    import Hero                      from '@/components/creator/Hero'
    import ProfileNavigation         from '@/components/creator/ProfileNavigation'
    import ProfileNavigationSkeleton from '@/components/creator/ProfileNavigationSkeleton'
    import FeedSkeleton              from '@/components/layout/main/FeedSkeleton'
    import Entries                   from '@/components/creator/Entries'
    import Drafts                    from '@/components/creator/Drafts'
    import Posts                     from '@/components/creator/Posts'
    import Unpublished               from '@/components/creator/Unpublished'
    import EmptyState                from '@/components/templates/EmptyState'

    export default {
        name: 'Creator',
        components: {
            BaseLayout,
            Main,
            Hero,
            ProfileNavigation,
            ProfileNavigationSkeleton,
            HeroSkeleton,
            FeedSkeleton,
            Entries,
            Drafts,
            Posts,
            Unpublished,
            EmptyState
        },
        props: {
            id: String
        },
        data() {
            return {
                isSelected:     'entries',
                fetchError:      false,
                userLoading:     true,
                feedSizeLoading: true,
                newEntryModal:   false,
                newPostModal:    false,
                feedSize: {
                    entries:     null,
                    entryDrafts: null,
                    posts:       null,
                    postDrafts:  null
                }
            }
        },
        computed: {
            ...mapState('users',['currentUser']),
        },
        async mounted() {
            var result = await this.fetchUser(this.id)

            if(result) {
                await this.calculateFeedSize()
            } else {
                this.fetchError = true
            }

            this.userLoading = false
        },
        methods: {
            ...mapActions('users',  ['fetchUser']),
            ...mapActions('journal',['purgeUserEntries']),

            updateProfile(u) {
                this.currentUser.avatar    = u.avatar
                this.currentUser.cover     = u.cover
                this.currentUser.name      = u.name
                this.currentUser.intro     = u.intro
                this.currentUser.instagram = u.instagram
                this.currentUser.website   = u.website
            },
            changeSelected(value) {
                this.isSelected = value
            },
            isVisible(selected) {
                var own   = this.isSelected === selected && this.id === this.auth.slug
                var admin = this.isSelected === selected && this.permissions.isAdmin 

                return own || admin 
            },
            async calculateFeedSize() {
                // entry count becomes 1 when this code is removed
                let entries = (await db
                    .collection('entries')
                    .where('creator.artist', '==', this.currentUser.id)
                    .where('flag.visibility', '==', true)
                    .get())
                    .size

                this.feedSize.entries = (await db
                    .collection('entries')
                    .where('creator.artist', '==', this.currentUser.id)
                    .where('flag.visibility', '==', true)
                    .get())
                    .size

                this.feedSize.posts = (await db
                    .collection('blog')
                    .where('author', '==', this.currentUser.id)
                    .where('visibility', '==', true)
                    .get())
                    .size

                this.feedSize.entryDrafts = (await db
                    .collection('entries')
                    .where('creator.artist', '==', this.currentUser.id)
                    .where('flag.visibility', '==', false)
                    .get())
                    .size

                this.feedSize.postDrafts = (await db
                    .collection('blog')
                    .where('author', '==', this.currentUser.id)
                    .where('visibility', '==', false)
                    .get())
                    .size

                this.feedSizeLoading = false
            }
        },
        watch: {
            // call again the method if the route changes
            '$route' (to, from) {
                this.userLoading = true
                this.fetchUser(this.id)
                this.userLoading = false
                if(from.name === 'creator') {
                    let feedSize = {
                        entries:     null,
                        entryDrafts: null,
                        posts:       null,
                        postDrafts:  null
                    }
                    this.purgeUserEntries()
                    this.feedSize = feedSize
                    this.calculateFeedSize()
                }
            }
        },
        beforeRouteEnter(to, from, next) {
        // Purge user entries when coming from related feed (entry page)
            next(vm => {
                if(from.name === 'entry') {
                    vm.purgeUserEntries()
                    setTimeout(() => {
                        window.scrollTo(0, 0)
                    })
                }
            })
        },
        metaInfo() {
            return {
                title: `${this.currentUser.name + ' | Creatillo'}`,
                meta: [
                    { vmid: 'description', name: 'description', content: this.currentUser.intro }
                ]
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../scss/variables';

</style>